"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var formik_1 = require("formik");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_2 = require("@escolalms/sdk/lib/react");
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../../../");
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  .lsm-input {\n    margin: 30px 0;\n  }\n  button {\n    margin-top: 10px;\n  }\n  p {\n    margin: 15px 0;\n  }\n  p,\n  a {\n    font-size: 14px;\n  }\n  h2,\n  h3,\n  h4 {\n    font-size: ", ";\n  }\n  form {\n    width: 100%;\n    min-width: ", ";\n    margin-bottom: 15px;\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  .lsm-input {\n    margin: 30px 0;\n  }\n  button {\n    margin-top: 10px;\n  }\n  p {\n    margin: 15px 0;\n  }\n  p,\n  a {\n    font-size: 14px;\n  }\n  h2,\n  h3,\n  h4 {\n    font-size: ", ";\n  }\n  form {\n    width: 100%;\n    min-width: ", ";\n    margin-bottom: 15px;\n  }\n"])), function (props) { return (props.mobile ? "18px" : "28px"); }, function (_a) {
    var mobile = _a.mobile;
    return (mobile ? "100%" : "440px");
});
var ResetPasswordForm = function (_a) {
    var onFirstStepError = _a.onFirstStepError, onSecondStepError = _a.onSecondStepError, onFirstStepSuccess = _a.onFirstStepSuccess, onSecondStepSuccess = _a.onSecondStepSuccess, backToLogin = _a.backToLogin, onRegisterLink = _a.onRegisterLink, _b = _a.mobile, mobile = _b === void 0 ? false : _b, return_url = _a.return_url, secondStep = _a.secondStep, email = _a.email, token = _a.token, _c = _a.className, className = _c === void 0 ? "" : _c;
    var initialValues = { email: "", password: "" };
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = (0, react_1.useContext)(react_2.EscolaLMSContext), forgot = _d.forgot, reset = _d.reset;
    var handleFirstStep = (0, react_1.useCallback)(function (values, setSubmitting, setErrors) {
        forgot({
            email: values.email,
            return_url: "".concat(return_url),
        })
            .then(function () { return onFirstStepSuccess && onFirstStepSuccess(); })
            .catch(function (err) {
            var _a;
            setErrors(__assign({ error: (_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message }, err.data.errors));
            onFirstStepError && onFirstStepError(err);
        })
            .finally(function () { return setSubmitting(false); });
    }, []);
    var handleSecondStep = (0, react_1.useCallback)(function (values, setSubmitting, setErrors) {
        reset({
            password: values.password,
            email: String(email),
            token: String(token),
        })
            .then(function () {
            onSecondStepSuccess && onSecondStepSuccess();
        })
            .catch(function (err) {
            var _a;
            setErrors(__assign({ error: (_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message }, err.data.errors));
            onSecondStepError && onSecondStepError(err);
        })
            .finally(function () { return setSubmitting(false); });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(StyledDiv, __assign({ className: "wellms-component ".concat(className), mobile: mobile }, { children: [(0, jsx_runtime_1.jsx)(__1.Title, __assign({ level: 3 }, { children: t("ResetForm.ResetPassword") })), " ", (0, jsx_runtime_1.jsx)(formik_1.Formik, __assign({ initialValues: initialValues, validate: function (values) {
                    var errors = {};
                    if (!values.email && !secondStep) {
                        errors.email = t("Required");
                    }
                    return errors;
                }, onSubmit: function (values, _a) {
                    var setSubmitting = _a.setSubmitting, setErrors = _a.setErrors;
                    !secondStep
                        ? handleFirstStep(values, setSubmitting, setErrors)
                        : handleSecondStep(values, setSubmitting, setErrors);
                } }, { children: function (_a) {
                    var values = _a.values, errors = _a.errors, touched = _a.touched, handleChange = _a.handleChange, handleBlur = _a.handleBlur, handleSubmit = _a.handleSubmit, isSubmitting = _a.isSubmitting;
                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [errors && errors.error && ((0, jsx_runtime_1.jsx)(__1.Text, __assign({ type: "danger" }, { children: errors.error }))), !secondStep ? ((0, jsx_runtime_1.jsx)(__1.Input, { type: "email", name: "email", label: t("Email"), onChange: handleChange, onBlur: handleBlur, value: values.email, error: touched.email && errors.email })) : ((0, jsx_runtime_1.jsx)(__1.Input, { type: "password", name: "password", label: t("Password"), onChange: handleChange, onBlur: handleBlur, value: values.password, error: touched.password && errors.password })), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ mode: "primary", type: "submit", loading: isSubmitting, block: true }, { children: t("ResetForm.Reset") }))] })));
                } })), !secondStep && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(__1.Text, __assign({ size: "14" }, { children: (0, jsx_runtime_1.jsx)(__1.Link, __assign({ underline: true, onClick: function () { return backToLogin && backToLogin(); } }, { children: t("ResetForm.BackToLogin") })) })), (0, jsx_runtime_1.jsxs)(__1.Text, __assign({ size: "13" }, { children: [t("Login.NoAccount"), " "] })), (0, jsx_runtime_1.jsx)(__1.Link, __assign({ onClick: function () { return onRegisterLink && onRegisterLink(); } }, { children: t("Login.Signup") }))] }))] })));
};
exports.ResetPasswordForm = ResetPasswordForm;
// https://styled-components.com/docs/api#using-custom-props
// Main button with styles
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.ResetPasswordForm)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2;
